<div class="overflow-hidden rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">
  <div class="flex flex-col gap-4 px-6 mb-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
        Recent Orders
      </h3>
    </div>
    <div class="flex items-center gap-3">
      <button class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-3 text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
        <svg class="stroke-current fill-white dark:fill-gray-800" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.29004 5.90393H17.7067" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.7075 14.0961H2.29085" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.0826 3.33331C13.5024 3.33331 14.6534 4.48431 14.6534 5.90414C14.6534 7.32398 13.5024 8.47498 12.0826 8.47498C10.6627 8.47498 9.51172 7.32398 9.51172 5.90415C9.51172 4.48432 10.6627 3.33331 12.0826 3.33331Z" fill="" stroke="" stroke-width="1.5"></path><path d="M7.91745 11.525C6.49762 11.525 5.34662 12.676 5.34662 14.0959C5.34661 15.5157 6.49762 16.6667 7.91745 16.6667C9.33728 16.6667 10.4883 15.5157 10.4883 14.0959C10.4883 12.676 9.33728 11.525 7.91745 11.525Z" fill="" stroke="" stroke-width="1.5"></path></svg>
        Filter
      </button>
      <button class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-3 text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
        See all
      </button>
    </div>
  </div>

  <div class="max-w-full overflow-x-auto">
    <table class="min-w-full">
      <thead class="px-6 py-3.5 border-t border-gray-100 border-y bg-gray-50 dark:border-white/[0.05] dark:bg-gray-900">
        <tr>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
            <div class="flex items-center gap-3">
              <div>
                <app-checkbox [checked]="selectAll" (checkedChange)="handleSelectAll()"/>
              </div>
              <div>
                <span class="font-medium text-gray-500 text-theme-xs dark:text-gray-400">
                  Deal ID
                </span>
              </div>
            </div>
          </th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Customer</th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Product/Service</th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Deal Value</th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Close Date</th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Status</th>
          <th class="px-6 py-3 font-medium text-gray-500 sm:px-6 text-theme-xs dark:text-gray-400 text-start">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (row of tableRowData; track $index) {
        <tr>
          <td class="px-4 sm:px-6 py-3.5">
            <div class="flex items-center gap-3">
              <div>
                <app-checkbox
                  [checked]="selectedRows.includes(row.id)"
                  (checkedChange)="handleRowSelect(row.id)"
                />
              </div>
              <div>
                <span class="block font-medium text-gray-700 text-theme-sm dark:text-gray-400">
                  {{ row.id }}
                </span>
              </div>
            </div>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            <div class="flex items-center gap-3">
              <app-avatar-text 
                [name]="row.user.name" 
                class="w-10 h-10"/>
              <div>
                <span class="mb-0.5 block text-theme-sm font-medium text-gray-700 dark:text-gray-400">
                  {{ row.user.name }}
                </span>
                <span class="text-gray-500 text-theme-sm dark:text-gray-400">
                  {{ row.user.email }}
                </span>
              </div>
            </div>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            <p class="text-gray-700 text-theme-sm dark:text-gray-400">
              {{ row.product.name }}
            </p>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            <p class="text-gray-700 text-theme-sm dark:text-gray-400">
              {{ row.product.price }}
            </p>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            <p class="text-gray-700 text-theme-sm dark:text-gray-400">
              {{ row.product.purchaseDate }}
            </p>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            <app-badge
              variant="light"
              [color]="getBadgeColor(row.status.type)"
              size="sm"
            >
              {{ row.status.type }}
            </app-badge>
          </td>
          <td class="px-4 sm:px-6 py-3.5">
            @if (row.actions.delete) {
            <button>
              <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-700 cursor-pointer size-5 hover:text-error-500 dark:text-gray-400 dark:hover:text-error-500"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.54142 3.7915C6.54142 2.54886 7.54878 1.5415 8.79142 1.5415H11.2081C12.4507 1.5415 13.4581 2.54886 13.4581 3.7915V4.0415H15.6252H16.666C17.0802 4.0415 17.416 4.37729 17.416 4.7915C17.416 5.20572 17.0802 5.5415 16.666 5.5415H16.3752V8.24638V13.2464V16.2082C16.3752 17.4508 15.3678 18.4582 14.1252 18.4582H5.87516C4.63252 18.4582 3.62516 17.4508 3.62516 16.2082V13.2464V8.24638V5.5415H3.3335C2.91928 5.5415 2.5835 5.20572 2.5835 4.7915C2.5835 4.37729 2.91928 4.0415 3.3335 4.0415H4.37516H6.54142V3.7915ZM14.8752 13.2464V8.24638V5.5415H13.4581H12.7081H7.29142H6.54142H5.12516V8.24638V13.2464V16.2082C5.12516 16.6224 5.46095 16.9582 5.87516 16.9582H14.1252C14.5394 16.9582 14.8752 16.6224 14.8752 16.2082V13.2464ZM8.04142 4.0415H11.9581V3.7915C11.9581 3.37729 11.6223 3.0415 11.2081 3.0415H8.79142C8.37721 3.0415 8.04142 3.37729 8.04142 3.7915V4.0415ZM8.3335 7.99984C8.74771 7.99984 9.0835 8.33562 9.0835 8.74984V13.7498C9.0835 14.1641 8.74771 14.4998 8.3335 14.4998C7.91928 14.4998 7.5835 14.1641 7.5835 13.7498V8.74984C7.5835 8.33562 7.91928 7.99984 8.3335 7.99984ZM12.4168 8.74984C12.4168 8.33562 12.081 7.99984 11.6668 7.99984C11.2526 7.99984 10.9168 8.33562 10.9168 8.74984V13.7498C10.9168 14.1641 11.2526 14.4998 11.6668 14.4998C12.081 14.4998 12.4168 14.1641 12.4168 13.7498V8.74984Z" fill="currentColor"></path></svg>
            </button>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>